function addDefaultWorkflowState(job) {
	if(!$.defaultWorkflowId) {
		return;
	}

	// Make double sure we aren't adding duplicate workflow states to the project
	// We also don't want to add the default workflow if we already have a valid app specific workflow
	$.plicAPI({
		method: 'projects/' + job.plicProjectId + '/workflow-states',
		params: {
			filter: {
				tagged_plic_app_id: $.plicSlug
			}
		},
		type: 'GET',
		success: function(data) {
			var workflows = data.workflows.filter(function(workflow) {
				return workflow.id == $.defaultWorkflowId;
			});
			if(!workflows.length) {
				$.plicAPI({
					method: 'workflow-states',
					params: {
						workflow_state: {
							project_id: job.plicProjectId,
							workflow_id: $.defaultWorkflowId
						}
					},
					success: function (data) {
						var state = data.workflow_state;

						if(state.workflow_item_states.length) {
							job.activeWorkflowItemId = state.workflow_item_states[0].workflow_item_id;
						} else {
							job.activeWorkflowItemId = 'unknown';
						}

						$.organizationDataTable.dataTable().fnDisplayUpdatedData(job);
					}
				});
			}
		}
	});
}
window.addDefaultWorkflowState = addDefaultWorkflowState;